<template>
  <div class="project">
    <div class="project-main">
      <div class="top-infro">
        <div>
          <div class="project-main-navbar nav-bar white">
            <van-nav-bar title="" left-arrow @click-left="onClickLeft" />
          </div>
        </div>
        <div class="project-name ellipsis1">
          山西省第三届家庭教育指导技能大赛（社会成人）
        </div>
        <div class="class-name ellipsis1">
          太原市赛区
        </div>
        <div class="box-wave">
          <div class="line"></div>
          <div class="shadow"></div>
          <div class="text">
            <div class="progress-value">0<span>%</span></div>
            <div class="progress"><i class="iconfont icon-shuoming"></i>总进度
            </div>
          </div>
          <div class="wave-progress">
            <div class="inner">
              <div class="water water1" style="top: 100%;"></div>
              <div class="water water2" style="top: 100%;"></div>
              <div class="tips"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-class common-box">
        <div class="title flex">
          <div>
            我的课堂<span>共1个阶段</span></div>
        </div>
        <div class="collapse-box">
          <div class="collapse-item">
            <div class="collapse-item-box">
              <div class="collapse-item-title">
                <div class="common not-started">
                  未开始
                </div>
                <div class="name">
                  <div>已完成报名，资格赛待开始</div>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-item__wrapper">
            <div class="collapse-item__content">
              <div class="segment-list-item">
                <div class="top-intro">
                  <div class="time">2025-09-27至2025-09-27</div>
                  <div class="title">已完成报名，资格赛待开始</div>
                </div>
                <div class="not-start"><img src="@/assets/img/sign/leave.png" alt="">
                  <div>此阶段未开始，请耐心等待</div>
                </div>
              </div>
            </div>
  
          </div>
  
        </div>
      </div>
  
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Search from 'vant/lib/search';
import 'vant/lib/search/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
Vue.use(Search)
Vue.use(NavBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Button)
Vue.use(Popup)
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      searchVal: '',
      showPicker: true,
      banner_bg: require("@/assets/img/bg-img/bg2.jpg"),
      activeTab: 0, // 必须为数字，0表示第一个标签[3,4](@ref)
      activeColor: "rgb(59, 112, 255)", // 直接写颜色值，无分号
      bgColor: "rgb(240, 240, 240)"    // 背景色示例（非必须）
    }
  },
  components: {



  },
  created() {

  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛报名'
  },

  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },




  },

}
</script>

<style lang="scss" scoped>
.project {
  height: 100%;

  .project-main {
    height: 100%;
    background-color: #f5f5f5;
    overflow-y: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    .top-infro {
      height: 272px;
      background: -webkit-gradient(linear, left bottom, left top, from(#5cafff), to(#1252ff));
      background: linear-gradient(1turn, #5cafff, #1252ff);
      color: #fff;
      position: relative;

      .project-main-navbar {
        height: 48px;

        ::v-deep i.van-nav-bar__arrow {
          color: #fff;
          z-index: 10000;
        }
      }

      .nav-bar {
        position: relative;


      }

      .project-name {
        font-size: 18px;
        word-break: break-all;
        padding-left: 19px;
        box-sizing: border-box;
      }

      .class-name {
        font-size: 15px;
        margin-top: 6px;
        padding-left: 19px;
      }

      .box-wave {
        width: 140px;
        height: 140px;
        position: relative;
        margin: 17px auto 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        @-webkit-keyframes line-data-v-47f7614d {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
          }

          to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
          }
        }

        @keyframes line-data-v-47f7614d {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
          }

          to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
          }
        }

        .line {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: url(../../assets/img/sign/line.6cf5dca.png) 50%;

          animation: line-data-v-47f7614d 5s linear infinite;
          background-size: cover;
        }

        .shadow {
          position: absolute;
          width: 3.52rem;
          height: 1.44rem;
          background: url(/m/static/img/shadow.06cd176.png) 50%;
          bottom: -.8rem;
          left: .05333rem;
          background-size: cover;
        }

        .text {
          width: 100%;
          top: 42px;
          text-align: center;
          z-index: 1;
          position: absolute;
          font-size: 37px;
          color: #fff;

          .progress-value {
            padding-left: 12px;
          }

          .progress {
            font-size: 10px;
            color: #f1f1f1;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
          }
        }

        .wave-progress {
          width: 131px;
          height: 131px;
          background: -webkit-gradient(linear, left top, left bottom, from(#005eff), to(#3000ff));
          background: linear-gradient(180deg, #005eff, #3000ff);
          opacity: .82;
          border-radius: 50%;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          overflow: hidden;
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);

          .inner {
            position: absolute;
            width: 118px;
            height: 118px;
            background: #639cff;
            border-radius: 50%;
            overflow: hidden;
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            z-index: 10;

            @-webkit-keyframes spin-data-v-47f7614d {
              0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg)
              }

              to {
                -webkit-transform: rotate(1turn);
                transform: rotate(1turn)
              }
            }

            @keyframes spin-data-v-47f7614d {
              0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg)
              }

              to {
                -webkit-transform: rotate(1turn);
                transform: rotate(1turn)
              }
            }

            .water {
              position: absolute;
              width: 200%;
              height: 200%;
              left: -50%;
              border-radius: 45%;
              background: -webkit-gradient(linear, left top, left bottom, from(#2600ff), to(#00ceff));
              background: linear-gradient(180deg, #2600ff, #00ceff);
              opacity: .49;
              -webkit-animation: spin-data-v-47f7614d 8s linear infinite;
              animation: spin-data-v-47f7614d 8s linear infinite;
              top: 40%;
            }

            .water2 {
              background: radial-gradient(#00ceff, #2600ff);
              -webkit-animation: spin-data-v-47f7614d 5s linear infinite;
              animation: spin-data-v-47f7614d 5s linear infinite;
              border-radius: 35%;
              top: 40%;
            }
          }
        }
      }
    }

    .my-class {
      padding-bottom: 42px;

      .collapse-box {
        padding: 10px 0 0;

        .collapse-item {
          // padding-bottom: 16.6px;

          .collapse-item-box {
            background-color: #e9e9e9;
            border-radius: 6px;
            padding: 10px 16px;

            .collapse-item-title {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;

              &>div {
                display: inline-block;
              }

              .not-started {
                background-color: #3b70ff;
              }



              .common {
                color: #fff;
                font-size: 12px;
                padding: 0 6px;
                height: 21px;
                line-height: 21px;
                border-radius: 2px;
              }

              .name {
                -webkit-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 17px;
                font-weight: 700;
                margin: 0 10px;
                color: #333;
                word-break: break-word;
                overflow: hidden;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
              }
            }
          }
        }

        .collapse-item__wrapper {
          border-radius: 6px;
          overflow: hidden;
          -webkit-transition: height .3s ease-in-out;
          transition: height .3s ease-in-out;
          will-change: height;

          .collapse-item__content {
            padding: 0 16px;
            border-top: 1px dashed #e0e0e0;
            color: #969799;
            font-size: 14px;
            line-height: 1.5;
            background-color: #fff;

            .segment-list-item {
              .top-intro {
                font-size: 14px;
                word-break: break-all;

                &>div+div {
                  margin-top: 5px;
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-align: center;
                  -ms-flex-align: center;
                  align-items: center;
                }

                .time {
                  font-size: 12px;
                  font-weight: 400;
                  color: #999;
                  line-height: 17px;
                }

                .title {
                  font-size: 14px;
                  font-weight: 400;
                  color: #666;
                  line-height: 21px;
                  margin: 4px 0 0;
                }
              }

              .not-start {
                text-align: center;
                font-size: 12px;
                padding: 21px 0;
                color: #999;

                img {
                  width: 40px;
                  height: 40px;
                  margin-bottom: 10px;
                }

                i {
                  color: #f5f5f5;
                  font-size: 41px;
                  margin-bottom: 10px;
                }
              }
            }
          }
        }
      }
    }

    .common-box {
      padding: 25px 18px;

      .title {
        font-size: 21px;
        font-weight: 700;

        span {
          margin-left: 10px;
          font-size: 13px;
          color: #999;
          font-weight: 400;
        }
      }

      .flex {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
    }
  }

}
</style>
